import React from "react";
import "../style/ThreeWayToggle.css";

const ThreeWayToggle = ({ changeTitleMode }) => {
  let pref;
  if(localStorage){
    pref = localStorage.getItem("titlePref")
  }
  return (
    <section className="ThreeWayToggle">
      <li
        onClick={() => changeTitleMode("English/Latin")}
        className={`toggle-btn ${pref === "English/Latin" ?'toggle-active' : ''}`}
      >
        English/Latin titles
      </li>
      <li onClick={() => changeTitleMode("English")} className={`toggle-btn ${pref === "English" ?'toggle-active' : ''}`}>
        English titles
      </li>
      <li onClick={() => changeTitleMode("Latin")} className={`toggle-btn ${pref === "Latin" ?'toggle-active' : ''}`}>
        Latin titles
      </li>
    </section>
  );
};

export default ThreeWayToggle;



// WEBPACK FOOTER //
// ./src/components/ThreeWayToggle.js